import { loadTrackingScripts } from "./loadScripts";
import { waitForConsentManager, openConsentTool, hasVideoConsentAsync, onConsentChange } from "./consentManager";
import { Logger } from "./logger";

/**
 * 🔹 Lädt alle CMP- und Tracking-Skripte dynamisch und behandelt Consent korrekt.
 */
export async function loadConsentAndTracking(): Promise<void> {
    try {
        Logger.info("🚀 Starte Laden von CMP + Tracking-Skripten...");

        // ⏬ Lade dynamisch alle Skripte (CMP + Tracking)
        await loadTrackingScripts();

        // ⏳ Warte, bis CMP im Fenster verfügbar ist
        waitForConsentManager(async () => {
            Logger.info("🟢 CMP erkannt und bereit.");

            const alreadyConsented = await hasVideoConsentAsync();
            Logger.info("📊 Initialer Consent-Status:", alreadyConsented);

            // 🧠 Optional: Consent-Tool öffnen, wenn noch kein Consent gesetzt
            if (!alreadyConsented) {
                Logger.info("📢 Consent fehlt – versuche Consent-Tool zu öffnen...");
                setTimeout(() => openConsentTool(), 1000);
            }

            // 🔁 Höre auf Consent-Änderungen
            onConsentChange(async () => {
                const updatedConsent = await hasVideoConsentAsync();
                if (updatedConsent) {
                    Logger.info("🔁 Neuer Consent – Tracking-Skripte werden nachgeladen...");
                    loadTrackingScripts(); // falls Tracking nachträglich geladen werden soll
                }
            });
        });
    } catch (err) {
        Logger.error("❌ Fehler beim Initialisieren von Consent und Tracking:", err);
    }
}
